import { createFileRoute, Link, useLoaderData, useRouter } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2 } from "lucide-react";
import { useEffect } from "react";

export const Route = createFileRoute("/onboarding/")({
  component: OnboardingIndex,
});

function OnboardingIndex() {
  const router = useRouter();
  const parentData = useLoaderData({ from: "/onboarding" }) as
    | { onboardingStatus?: { workspace_slug?: string | null } }
    | undefined;
  const workspaceSlug = parentData?.onboardingStatus?.workspace_slug ?? null;

  useEffect(() => {
    if (workspaceSlug) {
      const timer = setTimeout(() => {
        router.navigate({
          to: "/workspace/$workspaceSlug/new-task",
          params: { workspaceSlug },
        });
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [workspaceSlug, router]);

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle>Redirecting...</CardTitle>
        <CardDescription>
          We are setting up your workspace. If you are not redirected automatically, please click
          the button below.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4 items-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />

        {workspaceSlug && (
          <div className="flex flex-col gap-2 w-full">
            <Button asChild className="w-full">
              <Link to="/workspace/$workspaceSlug/new-task" params={{ workspaceSlug }}>
                Go to Workspace (Fallback)
              </Link>
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
